import { html } from 'htm/preact';

const Link = ({ text, onClick }) => {
  return html`
    <button class="mt-3 text-gray-500 text-xs md:text-sm transition hover-line-visible" onClick=${onClick}>
      ${text}
    </button>
  `;
};

export default Link;
